const __WEBPACK_NAMESPACE_OBJECT__ = kolibriCoreAppGlobal["kolibri/uiText/kolibriOnboardingGuideStrings"];